import React from "react";
import AddLanguageWizardStore from "../../../stores/add-language-wizard-store";
import AddLanguageWizardStepTitle from "../add-language-wizard-step-title";
import FileUpload, { FILE_UPLOAD_VARIANTS } from "../../../../../components/file-upload/file-upload";
import FontBody3 from "../../../../../components/fonts/font-body3/font-body3";
import "./upload-translations-step.scss";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";

interface IProps {
    wizardStore: AddLanguageWizardStore;
}

const UploadTranslationsStep: React.FC<IProps> = ({ wizardStore }) => {
    return (
        <>
            <AddLanguageWizardStepTitle
                title={"Third Step: Upload Your Translated File"}
                subtitle={"After adding your translations to the CSV, upload it here to enable the new language in the portal."}
            />
            <div className={"upload-button-container"}>
                <FileUpload
                    uploadFile={wizardStore.uploadTranslationsFile}
                    buttonText={"Upload File"}
                    variant={FILE_UPLOAD_VARIANTS.Secondary}
                    readType="text"
                    isLoading={wizardStore.isUploadingTranslationsFile}
                    fileTypes={["text/csv"]}
                />
            </div>
            <div className={"filename-label-container"}>
                <FontBody3 color={FONT_COLOR.SEMANTIC_SUCCESS}>{wizardStore.translationsFilename}</FontBody3>
            </div>
        </>
    );
}

export default UploadTranslationsStep;